<template>
  <div
    class="bg-gradient-to-r from-primary to-secondary text-white p-6 rounded-2xl shadow-2xl text-center border border-white/20 animate-fadeIn">
    <h2 class="text-3xl font-extrabold">{{ t(headlineKey) }}</h2>
    <p class="mt-2 text-lg opacity-90">
      {{ t(summaryKey, { score }) }}
    </p>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from "vue-i18n";
import { defineProps } from "vue";
import { useScoreStore } from "@/features/blueprint/stores/useScoreStore";
const { t } = useI18n();
const scoreStore = useScoreStore();

defineProps<{
  score: number;
  summaryKey: string;
  headlineKey: string;
}>();
</script>
